// src/containers/report/PerformanceWidget.jsx
import {Card, CardContent} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import React from "react";
import {useTranslation} from "react-i18next";
import {PerformanceCard} from "../../common/card/Cards";
import SectionHeader from "../../common/card/SectionHeader";
import {useGlobalState} from "../../GlobalContext";
import {useGasStationActivity} from "../../hooks/useGasStationActivity";
import {currencyCode, formatCurrency} from "../../utils/formatter";

const PerformanceWidget = ({
                               selectedGSZIds = [],
                               dateRange,
                           }) => {
    const { state } = useGlobalState();

    // Fetch dashboard data using our consolidated hook
    const {
        data: dashboardData,
        isLoading,
        error
    } = useGasStationActivity({
        market: state.country,
        selectedGSZIds,
        dateRange,
        enabled: selectedGSZIds.length > 0
    });

    // Get currency code for the current market/country
    const currency = currencyCode(state.country);

    // Process performance data
    const getFormattedValue = (value) => {
        if (!value) return "-";
        // Format number with thousands separator
        return formatCurrency(value, state.country, 0);
    };

    const getFormattedChange = (current, previous) => {
        if (current == null || previous == null) return "-";
        const diff = current - previous;
        const sign = diff >= 0 ? "+" : "";
        return `${sign}${getFormattedValue(diff)}`;
    };

    // Show error state if API call failed
    if (error) {
        console.error("Error fetching dashboard data:", error);
    }

    console.log("dashboardData", dashboardData)

    const { t } = useTranslation();

    return (
        <Grid2 container rowSpacing={1} columnSpacing={0} >
            <Grid2 xl={6} md={12} sx={{paddingRight: "8px"}}>
                <Card>
                    <CardContent>
                        <SectionHeader
                            title={t("Reports.Dashboard.DOValue")}
                            subtitle={t("Reports.Dashboard.InThisPeriod")}
                            description={t("Reports.Dashboard.ComparedToPrevious")}
                        />
                        <PerformanceCard
                            actualText={t("Reports.Dashboard.Reported")}
                            actualValue={isLoading ? "-" : getFormattedValue(dashboardData?.measured.driveoffValueInPeriod)}
                            actualUnit={currency}
                            actualChange={isLoading ? "-" : getFormattedChange(
                                dashboardData?.measured.driveoffValueInPeriod,
                                dashboardData?.measured.driveoffValueInPreviousPeriod
                            ) + " " + currency}
                            expectedText={t("Reports.Dashboard.Expected")}
                            expectedValue={isLoading ? "-" : getFormattedValue(dashboardData?.estimated?.driveoffValueInPeriod)}
                            expectedUnit={currency}
                            expectedChange={isLoading ? "-" : getFormattedChange(
                                dashboardData?.estimated?.driveoffValueInPeriod,
                                dashboardData?.estimated?.driveoffValueInPreviousPeriod
                            ) + " " + currency}
                            hasExpectedValues = {!!dashboardData?.estimated}
                        />
                    </CardContent>
                </Card>
            </Grid2>
            <Grid2 xl={6} md={12} sx={{paddingLeft: "8px"}}>
                <Card>
                    <CardContent>
                        <SectionHeader
                            title={t("Reports.Dashboard.DOCount")}
                            subtitle={t("Reports.Dashboard.InThisPeriod")}
                            description={t("Reports.Dashboard.ComparedToPrevious")}
                        />
                        <PerformanceCard
                            actualText={t("Reports.Dashboard.Reported")}
                            actualValue={isLoading ? "-" : getFormattedValue(dashboardData?.measured.driveoffCountInPeriod)}
                            actualUnit="" // No unit for count
                            actualChange={isLoading ? "-" : getFormattedChange(
                                dashboardData?.measured.driveoffCountInPeriod,
                                dashboardData?.measured.driveoffCountInPreviousPeriod
                            )}
                            expectedText={t("Reports.Dashboard.Expected")}
                            expectedValue={isLoading ? "-" : getFormattedValue(dashboardData?.estimated?.driveoffCountInPeriod)}
                            expectedUnit="" // No unit for count
                            expectedChange={isLoading ? "-" : getFormattedChange(
                                dashboardData?.estimated?.driveoffCountInPeriod,
                                dashboardData?.estimated?.driveoffCountInPreviousPeriod
                            )}
                            hasExpectedValues = {!!dashboardData?.estimated}
                        />
                    </CardContent>
                </Card>
            </Grid2>
        </Grid2>
    );
};

export default PerformanceWidget;